import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { AuthContext } from "../../Auth";
import { requestPost, requestGet } from "../../Helpers";
import { Card } from "../../Profile/MyPaymentMethods/Components/Card";
import { BtnGoBack, MainPaypal } from "../Components";




export const PurchaseDetail = () => {
  const { user } = useContext(AuthContext);

  const [myCards, setMyCards] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    try {
      const decode = jwtDecode(user.token);

      handleGetCards(decode?.user_id);
    } catch (error) {
      console.log(error);
    }
  }, [user]);

  const handleGetCards = (user) => {
    requestGet(`cards/?user=${user}`)
      .then((data) => {
        setMyCards(data ?? []);
      })
      .catch((error) => {
        setMyCards([]);
      });
  };

  const handleContinue = () => {
    navigate("/payment/confirm-purchase");
  };

  return (
    <div className="container mt-3">
      <div className="card">
        <div className="card-header">
          <h5 className="card-title">Detalle de la compra</h5>
        </div>
        <div className="row mt-3">
          <div className="col-12 col-md-6">
            {myCards?.results?.map((item) => {
              return (
                <div className="form-check" key={item.id}>
                  <input
                    className="form-check-input"
                    type="radio"
                    name="flexRadioDefault"
                    id="flexRadioDefault1"
                  />
                  <label className="form-check-label" htmlFor="flexRadioDefault1">
                    <Card
                      key={item.id}
                      typeCard={item.type_card}
                      numberCard={item.card_number}
                      nameCard={item.card_holder}
                      month={item.month}
                      year={item.year}
                      cvvCard={item.cvv}
                    />
                  </label>
                </div>
              );
            })}
          </div>
          <div className="col-12 col-md-6">
            <div className="stripe">
              {/* <MainStripe /> */}
            </div>
            <div className="mt-5 paypal">
              <MainPaypal />
            </div>
          </div>
          <div className="col-12">
            <br />
            <div className="d-flex justify-content-end">
              <BtnGoBack />
              &nbsp;
              <button className="btn btn-primary">Guardar</button>
              &nbsp;
              <button onClick={handleContinue} className="btn btn-success">
                Proceder a pagar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
